<template>
  <div class="status-bar ds-width-full">
    <div class="status-bar__dashboard ds-background-color-white">
      <!-- <div v-if="loading" class="ds-margin-bottom-24 status-loading status-bar__overview-item" />
      <div v-else class="ds-margin-bottom-24 ds-display-flex ds-align-items-center">
        <DsIcon
          :class="`ds-color-${status.icon.color}`"
          :category="status.icon.category"
          :name="status.icon.name"
        />
        <h2 class="ds-heading-xsmall ds-margin-left-12">
          {{ status.message }}
        </h2>
      </div>
      <DsDivider class="status-bar__dashboard__divider" /> -->
      <div
        v-for="(item, index) in items"
        :key="`status-bar-item-${index}`"
        class="ds-padding-24 ds-display-flex status-bar__status-item-wrapper"
        :class="isScreenSmall ? 'ds-flex-direction-column align-items-flex-start' : 'ds-align-items-center ds-justify-content-space-between'"
      >
        <div v-if="loading" class="status-loading status-bar__status-item" :class="`status-bar__status-item--${index}`" />
        <div
          v-else
          class="status-bar__status-item ds-display-flex ds-align-items-center"
          data-j-status-item
        >
          <!-- <DsIcon
            :class="`ds-color-${item.iconColor}`"
            category="shapes"
            name="dot"
            width="12"
            height="12"
          /> -->
          <DsIcon
            :class="`ds-color-${item.icon.color}`"
            :name="item.icon.name"
            :category="item.icon.category"
          />
          <div class="ds-padding-left-12 ds-padding-md-left-24">
            <h3 class="ds-text ds-font-weight-bold">
              {{ item.name }}
            </h3>
            <span class="ds-text-small ds-color-grey-450">
              {{ item.description }}
            </span>
          </div>
        </div>
        <div :class="{ 'ds-margin-top-12 ds-padding-left-12': isScreenSmall }">
          <div
            v-if="loading"
            class="status-loading"
            :style="{ height: '20px', display: 'block', width: '100px' }"
          />
          <div
            v-else
            class="ds-text-small ds-color-grey-450"
            :class="{ 'ds-margin-left-24': isScreenSmall }"
          >
            {{ item.status }}
          </div>
        </div>
      </div>
    </div>
    <div class="ds-margin-top-24">
      <div
        class="ds-display-flex"
        :class="{ 'ds-flex-direction-column': isScreenSmall }"
        v-if="loading"
      >
        <div
          v-for="index in legendItems.length"
          :key="`legend-loading-placeholder-${index}`"
          class="status-loading ds-margin-right-24"
          :class="{ 'ds-margin-top-12': isScreenSmall && index !== 1 }"
          :style="{ height: '20px', width: '100px' }"
        />
      </div>
      <div
        v-else
        class="ds-display-flex ds-flex-wrap ds-justify-content-center"
        :class="{ 'ds-flex-direction-column': isScreenSmall }"
      >
        <div
          v-for="(item, index) in legendItems"
          :key="`legend-item-${index}`"
          class="ds-display-flex ds-align-items-center ds-md-margin-right-24 ds-margin-bottom-12 ds-md-margin-bottom-0"
        >
          <DsIcon
            :class="`ds-color-${item.icon.color}`"
            :name="item.icon.name"
            :category="item.icon.category"
          />
          <span class="ds-text-small ds-color-grey-450 ds-margin-left-12">
            {{ item.text }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DsIcon from 'website-design-system/src/atoms/icon/icon'
// import DsDivider from 'website-design-system/src/atoms/divider/divider'
// import DsLegendGroup from 'website-design-system/src/molecules/legend-group/legend-group'
import { isScreenSmall } from '@/utils/screen'

export default {
  name: 'StatusOverview',
  components: { DsIcon },
  inject: ['screen', 'loading'],
  props: {
    status: {
      type: Object,
      required: true,
      validator: obj => ['icon', 'message'].every(key => key in obj)
    },
    items: {
      type: Array,
      required: true,
      validator: array => array.every(obj => ['iconColor', 'icon', 'name', 'description', 'status'].every(key => key in obj))
    },
    legendItems: {
      type: Array,
      required: true
    }
  },
  computed: {
    isScreenSmall () {
        return isScreenSmall(this.screen.name)
    }
  }
}
</script>

<style lang="scss">
@import 'website-design-system/src/foundation/tokens/variables';
@import 'website-design-system/src/foundation/mixins/mixins';

.status-bar {
  &__dashboard {
    border: 1px solid $color-grey;

    &__divider {
      margin-left: -$spacing-24;
      width: calc(100% + $spacing-48);
    }
  }

  &__overview-item {
    display: block;
    height: 30px;
    width: 188px;

    @include screen('medium') {
      width: 312px;
    }
  }

  &__status-item-wrapper {
    border-bottom: 1px solid $color-grey;
  }

  &__status-item-wrapper:last-child {
    border-bottom: 0;
  }

  &__status-item.status-loading {
    height: 20px;
    width: 164px;

    @include screen ('medium') {
      width: 300px;
    }

    &--1 {
      @include screen ('medium') {
        width: 368px;
      }
    }

    &--3 {
      @include screen ('medium') {
        width: 200px;
      }
    }
  }
}
</style>
